import React, { Suspense, useContext } from 'react';
import AddDeviationToobarButton from '@wix/da-editor-tiptap/pkg/components/menus/buttons/Deviation';
import GalleryToobarButton from '@wix/da-editor-tiptap/pkg/components/menus/buttons/Gallery';
import VideoToobarButton from '@wix/da-editor-tiptap/pkg/components/menus/buttons/Video';
import ReactionToobarButton from '@wix/da-editor-tiptap/pkg/components/menus/buttons/Reaction';
import HRuleToobarButton from '@wix/da-editor-tiptap/pkg/components/menus/buttons/HRule';
import GifToobarButton from '@wix/da-editor-tiptap/pkg/components/menus/buttons/Gif';
import MuroToolbarButton from '@wix/da-editor-tiptap/pkg/components/menus/buttons/MicroMuro';
import { EditorContext } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './CommentBoxToolbar.scss';
const CommentBoxToolbar = ({ width })=>{
    const { ref: editor } = useContext(EditorContext);
    const isMicroMuro = useFlag('micro_muro');
    return editor && // Suspense required since these buttons include a dynamically loaded translation namespace
    /*#__PURE__*/ React.createElement(Suspense, null, /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: {
            width: width !== null && width !== void 0 ? width : 'auto'
        }
    }, /*#__PURE__*/ React.createElement(AddDeviationToobarButton, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(GalleryToobarButton, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(VideoToobarButton, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(ReactionToobarButton, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(HRuleToobarButton, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(GifToobarButton, {
        editor: editor
    }), isMicroMuro && /*#__PURE__*/ React.createElement(MuroToolbarButton, {
        editor: editor
    })));
};
CommentBoxToolbar.displayName = 'CommentBoxToolbar';
export default CommentBoxToolbar;

//# sourceMappingURL=CommentBoxToolbar.js.map